import ContextReminderContainer from './containers/ContextReminderContainer'

export default ContextReminderContainer
